export const secret = {
    SECRET_KEY: '9SHFDYFWSKS45',
};
